import React from "react";
import { useParams } from "react-router-dom";
import Listings from "../components/Listings";
import { useTranslation } from "react-i18next";

export default function UserListings() {

  const { userId } = useParams();
  const { t } = useTranslation();

  return (
    <div style={{ padding: 20 }}>
      <h1>{t("profile.user_listings")}</h1>

      <Listings
        filter={{ userId }}
      />

    </div>
  );
}
